import { render, staticRenderFns } from "./community-hub-create.vue?vue&type=template&id=94635da4&scoped=true&"
import script from "./community-hub-create.ts?vue&type=script&lang=ts&"
export * from "./community-hub-create.ts?vue&type=script&lang=ts&"
import style0 from "./community-hub-create.scss?vue&type=style&index=0&id=94635da4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94635da4",
  null
  
)

export default component.exports